import { getTimeDisplayFromDate } from '@/utils';

type StatusDetailsProps = {
  beginn?: Date;
  ende?: Date;
  mitarbeiter?: { vorname: string; nachname: string };
};

export function StatusDetails({
  beginn,
  ende,
  mitarbeiter,
}: StatusDetailsProps) {
  return (
    <div className="text-sm text-neutrals-N700 font-normal">
      Für {getTimeDisplayFromDate(new Date(beginn))}
      <span className="px-[0.1rem]">-</span>
      {getTimeDisplayFromDate(new Date(ende))} Uhr von{' '}
      {mitarbeiter?.vorname + ' '}
      {mitarbeiter?.nachname}
    </div>
  );
}
